import React, { PureComponent } from 'react';
import ReactMarkdown from 'react-markdown';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { InfoIcon } from '../../../../../../../Icons';
import { PROP_TYPES } from 'constants';
import DocViewer from '../docViewer';
import './styles.scss';
import ThemeContext from '../../../../../../ThemeContext';
import MessageFeedback from '../../../../../MessageFeedback';
import { setMessageFeedback } from '../../../../../../../../store/actions';
import { sendEvent, buildEventPayload } from '../../../../../../../../api/analytics-client';

class Message extends PureComponent {
    handleLinkClick = (href) => {
        const { analyticsServiceUrl, sessionId } = this.props;
        if (analyticsServiceUrl && sessionId) {
            sendEvent(
                analyticsServiceUrl,
                buildEventPayload(sessionId, 'link_clicked', {
                    value: href,
                })
            );
        }
    };

    handleFeedback = (rating) => {
        const { message, messageIndex, analyticsServiceUrl, dispatch } = this.props;
        const messageId = message.get('messageId');

        // Update Redux state
        dispatch(setMessageFeedback(messageIndex, rating));

        // Send to backend if service URL configured
        if (analyticsServiceUrl) {
            const sessionId = this.props.sessionId || 'unknown';
            sendEvent(
                analyticsServiceUrl,
                buildEventPayload(sessionId, 'message_feedback', {
                    messageId,
                    value: rating,
                })
            );
        }
    };

    render() {
        const { docViewer, linkTarget, messageIndex } = this.props;
        const sender = this.props.message.get('sender');
        const text = this.props.message.get('text');
        const infoText = this.props.message.get('infoText');
        const customCss =
            this.props.message.get('customCss') && this.props.message.get('customCss').toJS();

        if (customCss && customCss.style === 'class') {
            customCss.css = customCss.css.replace(/^\./, '');
        }

        const { userTextColor, userBackgroundColor, assistTextColor, assistBackgroundColor } =
            this.context;
        let style;
        if (sender === 'response' && customCss && customCss.style === 'class') {
            style = undefined;
        } else if (sender === 'response' && customCss && customCss.style) {
            style = { cssText: customCss.css };
        } else if (sender === 'response') {
            style = { color: assistTextColor, backgroundColor: assistBackgroundColor };
        } else if (sender === 'client') {
            style = { color: userTextColor, backgroundColor: userBackgroundColor };
        }

        return text ? (
            <div className="rw-message-content">
                <div
                    className={`rw-message-wrapper ${sender === 'response' ? 'rw-message-wrapper--with-feedback' : ''}`}
                >
                    <div
                        className={
                            sender === 'response' && customCss && customCss.style === 'class'
                                ? `rw-response ${customCss.css}`
                                : `rw-${sender}`
                        }
                        style={style}
                    >
                        <div className="rw-message-text">
                            {sender === 'response' ? (
                                <div className={'rw-markdown'}>
                                    <ReactMarkdown
                                        //FD: comment-out due to incompat with the current react-markdown
                                        // linkTarget={(url) => {
                                        //   if (!url.startsWith('mailto') && !url.startsWith('javascript')) return '_blank';
                                        //   return undefined;
                                        // }}

                                        components={{
                                            a: (props) =>
                                                docViewer ? (
                                                    <DocViewer src={props.href}>
                                                        {props.children}
                                                    </DocViewer>
                                                ) : (
                                                    <a
                                                        href={props.href}
                                                        target={linkTarget || '_blank'}
                                                        rel="noopener noreferrer"
                                                        onMouseUp={(e) => e.stopPropagation()}
                                                        onClick={() =>
                                                            this.handleLinkClick(props.href)
                                                        }
                                                    >
                                                        {props.children}
                                                    </a>
                                                ),
                                        }}
                                    >
                                        {text}
                                    </ReactMarkdown>
                                </div>
                            ) : (
                                text
                            )}
                            {infoText ? (
                                <div className="rw-message-content-info-icon">
                                    <InfoIcon
                                        popupText={infoText}
                                        clickAwayRootId="rw-conversation-container"
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>
                    {sender === 'response' && (
                        <MessageFeedback
                            messageId={this.props.message.get('messageId')}
                            currentRating={this.props.message.get('feedbackRating')}
                            onFeedback={this.handleFeedback}
                            alwaysVisible={true}
                            allowChange={true}
                        />
                    )}
                </div>
            </div>
        ) : null;
    }
}

Message.contextType = ThemeContext;
Message.propTypes = {
    message: PROP_TYPES.MESSAGE,
    messageIndex: PropTypes.number,
    docViewer: PropTypes.bool,
    linkTarget: PropTypes.string,
    analyticsServiceUrl: PropTypes.string,
    sessionId: PropTypes.string,
    dispatch: PropTypes.func,
};

Message.defaultProps = {
    docViewer: false,
    linkTarget: '_blank',
    analyticsServiceUrl: null,
};

const mapStateToProps = (state) => ({
    linkTarget: state.metadata.get('linkTarget'),
    docViewer: state.behavior.get('docViewer'),
    analyticsServiceUrl: state.config.get('analyticsServiceUrl') || null,
    sessionId: state.config.get('sessionId') || null,
});

export default connect(mapStateToProps)(Message);
